<template>
  <div>
    <slot>Base tab control</slot>
  </div>
</template>

<script>
import { createComponent, ref, onCreated } from "@vue/composition-api";
import { onMounted } from "@vue/composition-api";
export default createComponent({
  setup({}, context) {}
});
</script>

<style lang="scss" scoped>
</style>